import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import topTerminal from '../../assets/technologies/siwoon/Siwoon_TopTerminal.png'
import sideTerminal from '../../assets/technologies/siwoon/Siwoon_SideTerminal.png'

const TOP_PARTS = [
  'Drawing Can', 'Bottom Retainer', 'Cap', 'R.P.T Conductor', 'Top Insulator',
  'Terminal', 'Bottom Insulator', 'Anode / Cathode Current Collector', 'Vent',
  'Seal Gasket', 'Side Retainer Tape', 'Disk', 'Seal Ball', 'Seal Pin', 'Rivet',
]

const SIDE_PARTS = [
  'Stack JR Cassette', 'Extrusion / Drawing Can', 'Anode / Cathode Cap Plate',
  'Anode / Cathode Side Insulator', 'Anode / Cathode Current Collector', 'Vent',
  'Terminal', 'Disk', 'Seal Ball', 'Temporary Pin',
]

const Siwoon = () => {
  return (
    <Page>
      {/* 1) Hero */}
      <Hero>
        <HeroInner>
          <HeroTitle>Siwoon (시운)</HeroTitle>
          <HeroSubtitle>
            리튬이온 이차전지용 Cap &amp; Can Assembly 부품 · 라세스 한국 독점 공급
          </HeroSubtitle>
        </HeroInner>
      </Hero>

      <Main>
        {/* 2) 회사 소개 */}
        <section>
          <Eyebrow>Company</Eyebrow>
          <SectionTitle>회사 소개</SectionTitle>
          <Lead>
            Siwoon Co., Ltd.는 이차전지(리튬이온 배터리)용 Cap &amp; Can Assembly 부품 생산을
            전문으로 하는 제조사입니다. 혁신적인 기술과 품질관리를 통해 한국 이차전지 산업의
            대표 기업으로 성장하는 것을 목표로 합니다.
          </Lead>
        </section>

        {/* 3) 주력 제품 */}
        <section>
          <Eyebrow>Products</Eyebrow>
          <SectionTitle>주력 제품</SectionTitle>
          <CardRow>
            <Card>
              <CardTitle>Cap Assembly</CardTitle>
              <CardText>
                이차전지 상단부를 덮어 전기적 안전을 확보하고 외부 환경으로부터 보호하는
                부품입니다. 고품질 소재로 뛰어난 내구성과 안전성을 확보합니다.
              </CardText>
            </Card>
            <Card>
              <CardTitle>Can Assembly</CardTitle>
              <CardText>
                배터리 외부 케이싱으로 구조적 안정성을 유지하고 내부 전기화학 반응을
                보호합니다. 정밀 제조 공정으로 고품질을 보장합니다.
              </CardText>
            </Card>
          </CardRow>
        </section>

        {/* 4) 핵심 강점 */}
        <section>
          <Eyebrow>Key Features</Eyebrow>
          <SectionTitle>핵심 강점</SectionTitle>
          <FeatureGrid>
            <Feature>
              <FeatureKo>정밀 성형 기술 및 고정밀 설계</FeatureKo>
              <FeatureEn>Precision molding &amp; high-precision design</FeatureEn>
            </Feature>
            <Feature>
              <FeatureKo>강한 내구성</FeatureKo>
              <FeatureEn>Strong durability</FeatureEn>
            </Feature>
            <Feature>
              <FeatureKo>안정적 열관리</FeatureKo>
              <FeatureEn>Stable thermal management</FeatureEn>
            </Feature>
            <Feature>
              <FeatureKo>자동화 생산 공정</FeatureKo>
              <FeatureEn>Automated production process</FeatureEn>
            </Feature>
            <Feature>
              <FeatureKo>엄격한 품질관리 시스템</FeatureKo>
              <FeatureEn>Strict quality control system</FeatureEn>
            </Feature>
          </FeatureGrid>
        </section>

        {/* 5) 제품 솔루션 */}
        <section>
          <Eyebrow>Solutions</Eyebrow>
          <SectionTitle>제품 솔루션</SectionTitle>
          <SolutionLead>
            Cap &amp; Can Assembly 솔루션을 위한 하기와 같은 각종 부품들을 제공합니다.
          </SolutionLead>

          <SolutionBlock>
            <SolutionHead>
              <SolutionNo>①</SolutionNo>
              <SolutionName>Top Terminal Type — Cap &amp; Can Assembly Solution</SolutionName>
            </SolutionHead>
            <Diagram
              src={topTerminal}
              alt="Siwoon Top Terminal Type Cap & Can Assembly 구성 다이어그램"
            />
          </SolutionBlock>

          <SolutionBlock>
            <SolutionHead>
              <SolutionNo>②</SolutionNo>
              <SolutionName>Side Terminal Type — Cap &amp; Can Assembly Solution</SolutionName>
            </SolutionHead>
            <Diagram
              src={sideTerminal}
              alt="Siwoon Side Terminal Type Cap & Can Assembly 구성 다이어그램"
            />
          </SolutionBlock>

          {/* 좌/우 2단 부품 비교 */}
          <SubTitle>구성 부품 비교</SubTitle>
          <CompareRow>
            <CompareCol>
              <CompareHead>① Top Terminal Type</CompareHead>
              <PartList>
                {TOP_PARTS.map((p) => (
                  <PartChip key={p}>{p}</PartChip>
                ))}
              </PartList>
            </CompareCol>
            <CompareCol>
              <CompareHead>② Side Terminal Type</CompareHead>
              <PartList>
                {SIDE_PARTS.map((p) => (
                  <PartChip key={p}>{p}</PartChip>
                ))}
              </PartList>
            </CompareCol>
          </CompareRow>
        </section>
      </Main>

      {/* 6) CTA */}
      <Cta>
        <CtaInner>
          <CtaEyebrow>라세스는 시운(Siwoon)의 한국 독점 에이전트(Sole Agent)입니다.</CtaEyebrow>
          <CtaTitle>시운 제품 문의 · 기술 상담</CtaTitle>
          <CtaButton to="/contact">문의하기</CtaButton>
        </CtaInner>
      </Cta>
    </Page>
  )
}

const Page = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  color: ${({ theme }) => theme.COLOR.BLACK};
`

/* ---------- Hero ---------- */
const Hero = styled.section`
  width: 100%;
  background: linear-gradient(135deg, #000063 0%, #0a2a6b 52%, #3e7edb 100%);
  display: flex;
  align-items: flex-end;
  min-height: 380px;

  @media (max-width: 900px) {
    min-height: 300px;
  }
`

const HeroInner = styled.div`
  padding: 56px 13%;
  width: 100%;

  @media (max-width: 900px) {
    padding: 40px 24px;
  }
`

const HeroTitle = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.COLOR.WHITE};
  font-size: ${({ theme }) => theme.SIZE.X1LARGE};
  font-weight: 700;
  line-height: 1.25;
  max-width: 900px;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.X05LARGE};
  }
`

const HeroSubtitle = styled.p`
  margin: 16px 0 0;
  color: rgba(236, 241, 255, 0.94);
  font-size: ${({ theme }) => theme.SIZE.LARGE};
  line-height: 1.6;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.MEDIUM};
  }
`

/* ---------- Main ---------- */
const Main = styled.div`
  padding: 80px 13%;
  display: flex;
  flex-direction: column;
  gap: 72px;

  @media (max-width: 1200px) {
    padding: 64px 8%;
    gap: 60px;
  }

  @media (max-width: 900px) {
    padding: 48px 24px;
    gap: 52px;
  }
`

const Eyebrow = styled.div`
  color: ${({ theme }) => theme.COLOR.MAGORELLEBLUE};
  font-size: ${({ theme }) => theme.SIZE.SMALL};
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  margin-bottom: 12px;
`

const SectionTitle = styled.h2`
  margin: 0 0 20px;
  font-size: ${({ theme }) => theme.SIZE.X05LARGE};
  font-weight: 600;
  line-height: 1.3;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.XLARGE};
  }
`

const Lead = styled.p`
  margin: 0;
  line-height: 1.8;
  font-size: ${({ theme }) => theme.SIZE.MEDIUM2};
  max-width: 900px;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.MEDIUM};
  }
`

/* ---------- Product cards ---------- */
const CardRow = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
  }
`

const Card = styled.div`
  flex: 1 1 0;
  background-color: #f5f8fd;
  border: 1px solid rgba(62, 126, 219, 0.16);
  border-radius: 14px;
  padding: 28px;
`

const CardTitle = styled.h3`
  margin: 0 0 12px;
  color: ${({ theme }) => theme.COLOR.MAGORELLEBLUE};
  font-size: ${({ theme }) => theme.SIZE.LARGE};
  font-weight: 700;
`

const CardText = styled.p`
  margin: 0;
  line-height: 1.7;
  font-size: ${({ theme }) => theme.SIZE.MEDIUM};
`

/* ---------- Key features ---------- */
const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`

const Feature = styled.div`
  border: 1px solid rgba(62, 126, 219, 0.2);
  border-top: 3px solid ${({ theme }) => theme.COLOR.MAGORELLEBLUE};
  border-radius: 12px;
  padding: 22px 18px;
  background-color: ${({ theme }) => theme.COLOR.WHITE};
`

const FeatureKo = styled.div`
  font-size: ${({ theme }) => theme.SIZE.MEDIUM2};
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 8px;
`

const FeatureEn = styled.div`
  font-size: ${({ theme }) => theme.SIZE.SMALL};
  color: #5a6474;
  line-height: 1.4;
`

/* ---------- Solutions ---------- */
const SolutionLead = styled(Lead)`
  font-size: ${({ theme }) => theme.SIZE.LARGE};

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.MEDIUM2};
  }
`

const SolutionBlock = styled.div`
  margin-top: 40px;
`

const SolutionHead = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`

const SolutionNo = styled.span`
  flex: none;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.COLOR.MAGORELLEBLUE};
  color: ${({ theme }) => theme.COLOR.WHITE};
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

const SolutionName = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.SIZE.LARGE};
  font-weight: 700;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.MEDIUM2};
  }
`

const Diagram = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.COLOR.RIGHTGRAY};
  box-shadow: 0 14px 34px rgba(15, 23, 66, 0.1);
`

const SubTitle = styled.h3`
  margin: 56px 0 20px;
  font-size: ${({ theme }) => theme.SIZE.XLARGE};
  font-weight: 700;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.LARGE};
  }
`

const CompareRow = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 20px;
  }
`

const CompareCol = styled.div`
  flex: 1 1 0;
  min-width: 0;
  background-color: #f5f8fd;
  border: 1px solid rgba(62, 126, 219, 0.16);
  border-radius: 14px;
  padding: 24px;
`

const CompareHead = styled.div`
  color: ${({ theme }) => theme.COLOR.DARKBLUE};
  font-size: ${({ theme }) => theme.SIZE.MEDIUM2};
  font-weight: 700;
  padding-bottom: 14px;
  margin-bottom: 16px;
  border-bottom: 2px solid rgba(62, 126, 219, 0.28);
`

const PartList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

const PartChip = styled.li`
  padding: 8px 14px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  border: 1px solid rgba(62, 126, 219, 0.24);
  font-size: ${({ theme }) => theme.SIZE.SMALL};
  color: #2a3242;
`

/* ---------- CTA ---------- */
const Cta = styled.section`
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(135deg, #000063 0%, #123a86 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 72px 24px;
`

const CtaInner = styled.div`
  text-align: center;
  max-width: 720px;
`

const CtaEyebrow = styled.div`
  color: rgba(236, 241, 255, 0.9);
  font-size: ${({ theme }) => theme.SIZE.MEDIUM};
  font-weight: 600;
  margin-bottom: 14px;
`

const CtaTitle = styled.h2`
  margin: 0 0 26px;
  color: ${({ theme }) => theme.COLOR.WHITE};
  font-size: ${({ theme }) => theme.SIZE.X05LARGE};
  font-weight: 700;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.XLARGE};
  }
`

const CtaButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 14px 44px;
  border-radius: 999px;
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  color: ${({ theme }) => theme.COLOR.DARKBLUE};
  font-size: ${({ theme }) => theme.SIZE.MEDIUM2};
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.18s ease, background-color 0.18s ease;

  &:hover {
    background-color: ${({ theme }) => theme.COLOR.MAGORELLEBLUE};
    color: ${({ theme }) => theme.COLOR.WHITE};
    transform: translateY(-2px);
  }
`

export default Siwoon
